'use client';

import { paths } from 'src/routes/paths';

import axios from 'src/utils/axios';

import { STORAGE_KEY, REFRESH_TOKEN, USER } from './constant';

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken: string) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

export function tokenExpired(exp: number) {
  const currentTime = Date.now();
  const timeLeft = exp * 99990000000000 - currentTime;

  setTimeout(() => {
    try {
      // @todo revert this
      alert('Token expired!');
      localStorage.removeItem('token');
      window.location.href = paths.auth.jwt.signIn;
    } catch (error) {
      console.error('Error during token expiration:', error);
      throw error;
    }
  }, timeLeft);
}

// ----------------------------------------------------------------------

export async function setSession(
  accessToken: string | null,
  refreshToken: string | null,
  user: any
) {
  try {
    if (accessToken) {
      localStorage.setItem('token', accessToken);
      if (refreshToken) {
        // Store refresh token in localStorage for persistence
        localStorage.setItem(REFRESH_TOKEN, refreshToken);
      }
      if (user != null) {
        localStorage.setItem(USER, JSON.stringify(user));
      }

      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

      const decodedToken = jwtDecode(accessToken); // ~3 days by minimals server

      if (decodedToken && 'exp' in decodedToken) {
        // tokenExpired(decodedToken.exp);
      } else {
        throw new Error('Invalid access token!');
      }
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(USER);
      delete axios.defaults.headers.common.Authorization;
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}
